require('./es6.array.iterator');
var Iterators = require('./$.iterators');
Iterators.NodeList = Iterators.HTMLCollection = Iterators.Array;


/** WEBPACK FOOTER **
 ** ./~/react-native-winjs/~/core-js/library/modules/web.dom.iterable.js
 **/